import { Market, OpenOrders } from "@openbook-dex/openbook";
import { PublicKey, ConfirmOptions, Transaction } from "@solana/web3.js";
import { Program } from "@coral-xyz/anchor";
import { IDL } from "./idl";
import { sendSerializedTransactions, signTransactions } from "ts/executeSwap";
import { closedOpenOrders, setOpenOrders } from "redux/state";

export const DEX_PID = new PublicKey("srmqPvymJeFKQ4zGQed1GFppgkRHL9kaELCbyksJtPX");

export async function fetchOpenOrders(state: any) {
    let rawOpenOrdersAccounts: any = await OpenOrders.findForOwner(
        state.connection,
        state.publicKey,
        DEX_PID,
    ).catch((e) => {return []});
    for (let i=0; i<rawOpenOrdersAccounts.length; i++) {
        let market = await Market.load(state.connection, rawOpenOrdersAccounts[i].market, undefined, DEX_PID);
        rawOpenOrdersAccounts[i] = {
            ...rawOpenOrdersAccounts[i],
            base: market.baseMintAddress,
            quote: market.quoteMintAddress,
        }
    }
    return rawOpenOrdersAccounts;
}

export async function closeOpenOrders(state, dispatch, market, openOrders) {
    dispatch(closedOpenOrders({status:"clicked"}));
    const wallet = state.wallet;
    if (!wallet) {
        return null;
    }
    const opts: ConfirmOptions = {
        preflightCommitment: "recent",
        commitment: "recent",
    };
    const provider = new Provider(
        state.connection,
        wallet,
        opts
    );
    const program = new Program(IDL, new PublicKey("22Y43yTVxuUkoRKdm9thyRhQ3SdgQS7c7kB6UNCiaczD"), provider);
    let closeTx = await program.rpc.closeAccount({
      accounts: {
        openOrders: openOrders,
        authority: wallet.publicKey,
        market: market,
        dexProgram: DEX_PID,
        destination: wallet.publicKey,
      },
    }).catch((e) => null);

    if (closeTx) {
        let updatedList = [];
        for (let i = 0; i < state.openOrders.length; i++)
          if (state.openOrders[i].address.toBase58() != openOrders)
            //@ts-ignore
            updatedList.push(state.openOrders[i]);
        
        dispatch(closedOpenOrders({
          status: "generating",
          txId: closeTx,
          link: "https://solscan.io/tx/"+closeTx,
        }));
        dispatch(setOpenOrders(updatedList));
        return true;
    }

    return null;
}

export async function applyRecentBlockHash(connection, initializer, tx, blockhash) {
    tx.recentBlockhash = blockhash;
    tx.setSigners(initializer);
    return tx;
  }

export async function closeAllOpenOrders(state, dispatch) {
  dispatch(closedOpenOrders({status:"clicked"}))
    const wallet = state.wallet;
    if (!wallet) {
        return null;
    }
    const opts: ConfirmOptions = {
        preflightCommitment: "recent",
        commitment: "recent",
    };
    const provider = new Provider(
        state.connection,
        wallet,
        opts
    );
    const program = new Program(IDL, new PublicKey("22Y43yTVxuUkoRKdm9thyRhQ3SdgQS7c7kB6UNCiaczD"), provider);

    let txs: any = [];
    let tx = new Transaction();
    
    let { blockhash } = await state.connection.getRecentBlockhash('max');

    for (let i=0; i<state.openOrders.length;i++) {
        tx.add(program.instruction.closeAccount({
            accounts: {
            openOrders: state.openOrders[i].address,
            authority: wallet.publicKey,
            market: state.openOrders[i].market,
            dexProgram: DEX_PID,
            destination: wallet.publicKey,
            },
        }));
        if (tx.instructions.length == 8) {
            tx = await applyRecentBlockHash(state.connection, wallet.publicKey, tx, blockhash); 
            txs.push(tx);
            tx = new Transaction();
        }
    }
    if (tx.instructions.length > 0) {
        tx = await applyRecentBlockHash(state.connection, wallet.publicKey, tx, blockhash); 
        txs.push(tx);
    }

    let serializeResult: any = await signTransactions(wallet, txs);

    if (!serializeResult.serialized)
        return null;
    
    let result = await sendSerializedTransactions(state.connection, serializeResult.serialized, 0);

    if (result.txId) {
      dispatch(closedOpenOrders({
        status: "generating",
        txId: result.txId,
        link: result.link,
      }))
      dispatch(setOpenOrders([]));
      return true;
    }
    
    return null;
}
